import { Button } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './SafeRentDescription.css';
import { IContent } from './content';
import { trackSafeRentDescriptionShow, trackSafeRentDescriptionClick } from './tracking';

export interface ISafeRentDescriptionProps {
  id: number;
  content: IContent;
  openModal(): void;
}

const advIcon = require('./assets/adv.svg') as string;

export const SafeRentDescription = ({ id, content, openModal }: ISafeRentDescriptionProps) => {
  /* istanbul ignore next */
  React.useEffect(() => {
    trackSafeRentDescriptionShow(id);
  }, [id]);

  return (
    <div id="safe-rent" className={styles['block']}>
      <div className={styles['title']}>
        {content.title.map((item: string) => (
          <div key={item}>{item}</div>
        ))}
      </div>

      <div className={styles['list']}>
        {content.advsList.map((item: string) => (
          <div key={item} className={styles['list-item']}>
            <img src={advIcon} className={styles['list-icon']} />
            <span>{item}</span>
          </div>
        ))}
      </div>

      <Button
        custom={{ type: 'primary', mediaType: 'mobile' }}
        onClick={() => {
          trackSafeRentDescriptionClick(id);
          openModal();
        }}
      >
        <span className={styles['button-text']}>{content.buttonText}</span>
      </Button>
    </div>
  );
};
